import { Logout, LogoutSpinner } from '../ProfileMenu.styles';

const ProfileMenuLogoutButton = ({ onLogout, isLoggingOut, logOutLabel, loggingOutLabel }) => (
	<Logout type="button" onClick={onLogout} disabled={isLoggingOut}>
		{isLoggingOut ? (
			<>
				<LogoutSpinner />
				{loggingOutLabel}
			</>
		) : (
			logOutLabel
		)}
	</Logout>
);

export default ProfileMenuLogoutButton;
